export const ORDER_STATUS_FLOW = [
    { key: 'CREADO', label: 'Creado', color: 'default', phase: 'Registro' },
    { key: 'VALIDADA', label: 'Validada', color: 'info', phase: 'Validación' },
    { key: 'LIBERADA', label: 'Liberada', color: 'primary', phase: 'Planificación' },
    { key: 'EN_EJECUCION', label: 'En ejecución', color: 'warning', phase: 'Operación' },
    { key: 'FINALIZADA', label: 'Finalizada', color: 'success', phase: 'Cierre operativo' },
    { key: 'PRE_VALORIZADA', label: 'Pre valorizada', color: 'default', phase: 'Pre valorizada' },
    { key: 'VALORIZADA', label: 'Valorizada', color: 'secondary', phase: 'Valorización' },
    { key: 'FACTURADA', label: 'Facturada', color: 'info', phase: 'Facturación' },
    { key: 'CERRADA', label: 'Cerrada', color: 'success', phase: 'Cierre administrativo' },
    { key: 'CANCELADA', label: 'Cancelada', color: 'error', phase: 'Cancelación' },
];

export const STATUS_CONFIG = ORDER_STATUS_FLOW.reduce((acc, item) => {
    acc[item.key] = item;
    return acc;
}, {});

export const ALERT_CONFIG = {
    ORDEN_ATRASADA: {
        label: 'Orden atrasada',
        severity: 'error',
    },
    FINALIZADA_NO_VALORIZADA: {
        label: 'Finalizada sin valorizar',
        severity: 'warning',
    },
    VALORIZADA_NO_FACTURADA: {
        label: 'Valorizada sin facturar',
        severity: 'warning',
    },
    FACTURADA_NO_CERRADA: {
        label: 'Facturada sin cerrar',
        severity: 'info',
    },
    MANIFIESTOS_PENDIENTES: {
        label: 'Manifiestos pendientes',
        severity: 'error',
    },
    LIBERADA_SIN_MANIFIESTOS: {
        label: 'Liberada sin manifiestos',
        severity: 'warning',
    },
};